var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InfoLabel',{attrs:{"label":_vm.field.label}},[_c('div',{directives:[{name:"sanitized-html",rawName:"v-sanitized-html",value:(_vm.field.html),expression:"field.html"}]})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }